export default __webpack_public_path__ + "static/media/ws.96f7044f.svg";